import { OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-block-user-dialog',
  templateUrl: './block-user-dialog.component.html',
  styleUrls: ['./block-user-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BlockUserDialog implements OnInit {
  info: any;
  summary = '';

  constructor(
    private _dialogRef: MatDialogRef<BlockUserDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.summary = '';
  }

  ngOnInit() {
    if (this.data) {
      this.info = this.data;
      this.summary = this.info.msgBlockedPatronSummary;
    }
  }

  close() {
    this._dialogRef.close('close');
  }
}
